import { useEffect, useState } from 'react';

// Returns `value` once it has stopped changing for `delay` ms.
//
// List pages bind their input to the raw value and key their fetch off this
// one, so typing stays instant but only the pause reaches the API.
//
// Debouncing the *fetch* is the part that was missing. Assets already had an
// effect labelled "Debounce search", but it deferred only the page reset —
// `search` sat directly in the fetch callback's dependencies, so every
// keystroke still fired a request.
export default function useDebouncedValue(value, delay = 350) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
}
